import MessageComponent from "./MessageComponent";

const ChatMessages = ({ 
  messages, 
  isTyping, 
  connectionStatus, 
  messagesEndRef,
  leftSidebarOpen = false,
  rightSidebarOpen = false
}) => {
  // Show loading screen when loading chat history
  if (connectionStatus === "loading" && messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <div className="text-center py-12">
          <div className="animate-spin h-8 w-8 border-b-2 border-electric-blue mx-auto mb-4"></div>
          <p className="text-gray-500">Loading conversation history...</p>
        </div>
      </div>
    );
  }

  // Calculate responsive width based on sidebar states
  // const getContainerWidth = () => {
  //   if (window.innerWidth >= 1024) {
  //     // Desktop: adjust based on sidebar states
  //     if (leftSidebarOpen && rightSidebarOpen) {
  //       return "max-w-4xl"; // Both sidebars open
  //     } else if (leftSidebarOpen || rightSidebarOpen) {
  //       return "max-w-5xl"; // One sidebar open
  //     } else {
  //       return "max-w-6xl"; // Both sidebars closed - full width
  //     }
  //   } else {
  //     // Mobile: always use full width since sidebars overlay
  //     return "max-w-full";
  //   }
  // };

  return (
    <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
      <div className="max-w-6xl mx-auto space-y-6">
        {messages.map((message) => (
          <MessageComponent key={message.id} message={message} />
        ))}
        
        {/* {isTyping && (
          <div className="flex justify-start">
            <div className="bg-white border border-gray-200 p-4 max-w-md shadow-sm">
              <div className="flex items-center space-x-2">
                <div className="animate-spin h-4 w-4 border-b-2 border-electric-blue"></div>
                <span className="text-gray-600">AI is thinking...</span>
              </div>
            </div>
          </div>
        )} */}
        
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatMessages;